module.exports = __webpack_public_path__ + "img/lover.885f3eab.png";